export default "__VITE_ASSET__2tATjkN7__"